<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col d-flex align-items-center justify-content-center">
      <img src="../assets/img/logo/bird.png" height="80px">
    </div>
  </div>
</div>
